const CheckInDashboard = () => {
  return <div>CheckInDashboard</div>;
};

export default CheckInDashboard;
